/**
 * Created by kevinqueeney on 24/07/2015.
 */

angular.module('qkr.tax').config(($routeSegmentProvider, appUrl) => {
    $routeSegmentProvider.options.autoLoadTemplates = true;

    $routeSegmentProvider.
        when('/tax/settings', 'taxsettings', { pageTitle: 'Tax Settings' });

    $routeSegmentProvider.
        segment('taxsettings', {
            template: require('../templates/taxsettings.html'),
            controller: 'TaxSettingsController',
            resolve: {
                merchant($rootScope, $q, merchantService) {
                    'ngInject';
                    const deferred = $q.defer();

                    if ($rootScope.merchantInfo != null) {
                        deferred.resolve($rootScope.merchantInfo);
                    } else {
                        merchantService.refreshMerchantInfo().then((response) => {
                            deferred.resolve(response);
                        });
                    }
                    return deferred.promise;
                },
                outlets($q, outletService) {
                    'ngInject';
                    const deferred = $q.defer();
                    outletService.listOutlets().then((response) => {
                        deferred.resolve(response);
                    });
                    return deferred.promise;
                },
                taxRegionOverrideList($q) {
                    'ngInject';
                    const deferred = $q.defer();
                    deferred.resolve([]);
                    return deferred.promise;
                }
            }
        });
});




// WEBPACK FOOTER //
// ./src/tax/config/tax.config.js